import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('article/list', { params });
  },
  async add(params: any) {
    return axios.post('article/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('article/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('article/info', { params });
  },
  async delete(params: any) {
    return axios.post('article/delete', qs.stringify(params));
  }
};
